import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
import Popover from 'researcher/components/Popover';
export var RubriqAbstractStatusTooltip = function RubriqAbstractStatusTooltip() {
  return /*#__PURE__*/React.createElement(Popover, {
    content: "curie.premium-access-abstract-tooltip",
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-info"
  }));
};
var RubriqAbstractStatus = function RubriqAbstractStatus(_ref) {
  var _ref$isNoAbstractMess = _ref.isNoAbstractMessage,
    isNoAbstractMessage = _ref$isNoAbstractMess === void 0 ? true : _ref$isNoAbstractMess;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2 flex-md-row gap-md-3 ".concat(isNoAbstractMessage ? 'align-items-center' : 'align-items-start align-items-md-center')
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-check"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Full access"
  }), /*#__PURE__*/React.createElement(RubriqAbstractStatusTooltip, null)));
};
export default RubriqAbstractStatus;